import React from "react";
import "./LegalContent.styles.css";
import { Helmet } from "react-helmet";

const RefundPolicyPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cm-legal-content-container">
      <Helmet>
        <title>Globalskyfare | Refund & Cancellation</title>
      </Helmet>
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">Refund and Cancellation Policy</h2>
      </div>
      <div className="cm-section  cm-page-center cm-lr-pad">
        <p>After 24 hours of booking, most airline tickets and service charges are non-refundable.</p>
        <p>If travel has not yet begun and the consumer has contacted our customer service center at <a href="tel:+18002650080"><strong>+1-800-265-0080</strong></a> to cancel the trip protection insurance, the money will be returned within 10 days of the purchase.</p>
        <p>Calling Globalskyfare.com customer support at (Phone Number) is the sole way to make any cancellations.</p>
        <p>Refund claims for airline tickets are only accepted if the following requirements are fulfilled:</p>
        <ul>
          <li>The customer has applied for a cancellation and refund with us;</li>
          <li>
            The fare rule(s) under which the airline ticket is booked provide options for cancellation and refunds;
          </li>
          <li>
            Each passenger whose name is on the airline ticket is not a "No Show" (most "no show" bookings are not eligible for any waiver from airlines for refund processing); and
          </li>
          <li>
            We can secure waivers from airlines to process the requested cancellation and refund of the ticket.
          </li>
        </ul>
        <p>Please be aware that we cannot give an exact timeline for how long the airlines could take to complete your refund request.</p>
        <ul>
          <li>Every refund request is handled methodically.</li>
          <li>A refund-request-received email message will be sent to the client who has requested a refund when our customer care representative has received their cancelation request.</li>
          <li>After receiving the notification, the consumer is not immediately eligible for a refund. All that is provided is a tracking number and an acknowledgment of the request.</li>
          <li>After receiving the refund request, we will collaborate with the airlines and other suppliers to create a waiver in accordance with airline and other supplier regulations. We will then inform the client of the supplier's decision.</li>
          <li>Our Assistance Refunds are unavailable for fees related to the initial travel reservation or booking.</li>
        </ul>
        <p>Please be aware that we rely on the airlines and suppliers (collectively referred to as "suppliers") to provide the reimbursements that we have requested.</p>
        <ul>
          <li>It could take longer for the returned amount to show up on the customer's credit card account once the supplier has authorized the refund.</li>
          <li>All vendors often impose a penalty for refunds.</li>
          <li>The full procedure might take 60 to 90 days from the time a refund request is received until the credit appears on the card statement.</li>
          <li>Globalskyfare.com will impose a post-ticketing services fee, if applicable, in addition to the refund penalties imposed by the providers.</li>
          <li>Every refund cost is assessed on a per-ticket, per-passenger basis. These costs will only be incurred if the supplier has approved a refund or a waiver has been obtained and only if the provider's policies allow for such reimbursements.</li>
          <li>If the supplier is unable to effectuate the refund, we will reimburse you the post-ticketing service fees related to the agent-assisted refund request; however, we will not reimburse you for the original booking or travel reservation expenses.</li>
        </ul>
        <p>Please note that reservations may only be canceled by phone at <a href="tel:+18002650080"><strong>+1-800-265-0080</strong></a>, not via email or online chat, for your protection.</p>
        <ul>
          <li>When a customer asks Globalskyfare.com to cancel a ticket reservation, our representatives will issue a unique cancellation password to the email address provided when the booking was made.</li>
          <li>To complete the cancellation request, the consumer requesting the refund must give our representatives their unique cancellation password when prompted.</li>
          <li>We might be unable to complete the cancellation request if the client cannot access the email given and cannot provide our customer support representatives the Unique Cancellation Password.</li>
          <li>The unique cancellation password expires three hours after it is issued. If the current one expires before the refund request is handled, the consumer must call us again to get a new one.</li>
        </ul>
      </div>
    </div >
  );
};

export default RefundPolicyPage;
